import { useEffect, useState } from 'react';
import { useGlobalSearchParams } from 'expo-router';
import { useAuthStore } from '@/store';
import { useWorkModeDisabled } from '@/lib/workModeAvailability';
import useAppActive from '@/hooks/useAppActive';
import useWorkStarterPrompts from '@/hooks/useWorkStarterPrompts';
import useChatStarterPrompts from '@/hooks/useChatStarterPrompts';

const CACHE_CHECK_INTERVAL_MS = 60 * 1000;

// Warm both modes in the app shell so the next new chat is ready. Only Work
// follows the selected Mac project; Chat always uses account memory.
export default function WorkStarterPromptsPreloader() {
  const active = useAppActive();
  const workDisabled = useWorkModeDisabled();
  const params = useGlobalSearchParams();
  const signedIn = useAuthStore((s) => !!s.token && !!s.user?.id && !s._isSigningOut);
  const enabled = active && signedIn && params?.['temporary-chat'] !== 'true';
  const [refreshKey, setRefreshKey] = useState(0);
  useWorkStarterPrompts({ enabled: enabled && !workDisabled, refreshKey });
  useChatStarterPrompts({ enabled, refreshKey });

  useEffect(() => {
    if (!enabled) return undefined;
    // Fresh cache checks are local; only an expired entry starts a request.
    const timer = setInterval(() => setRefreshKey((key) => key + 1), CACHE_CHECK_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [enabled]);
  return null;
}
